export class LazyLoad {

    constructor() {

    }

    init() {
        // lazy load : PC Safari 対策
        let ua = window.navigator.userAgent.toLowerCase();
        //console.log(ua);
        if (ua.indexOf('safari') !== -1 && ua.indexOf('mobile') === -1 && ua.indexOf('chrome') === -1 && ua.indexOf('edge') === -1) {
            console.log('data-src');
            if (document.querySelectorAll('img')[0]) {
                let lzTarget = document.querySelectorAll('img');
                for (let i = 0; i < lzTarget.length; i++) {
                    if (lzTarget[i].hasAttribute("data-src")) {
                        let srcLazy = lzTarget[i].dataset.src;
                        lzTarget[i].setAttribute('src', srcLazy);
                        lzTarget[i].classList.add('src-lazy-replaced');
                    }
                }
            }
        }
    }

}